import { Alert, Snackbar } from '@mui/material';
import { SyntheticEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetAlertData } from '../../stores/alertStore';
import { RootState } from '../../stores/globalStore';

function AlertHandler() {
  const open = useSelector((state: RootState) => state.alertHandler.open);
  const alertServerity = useSelector((state: RootState) => state.alertHandler.severity);
  const alertMessage = useSelector((state: RootState) => state.alertHandler.message);

  const dispatch = useDispatch();

  const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(resetAlertData());
  };

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={alertServerity} sx={{ width: '100%' }}>
        {alertMessage}
      </Alert>
    </Snackbar>
  );
}

export default AlertHandler;
